module.exports = __webpack_public_path__ + "img/微信认证.425752a2.png";